import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedSupplier } from 'contracts/Suppliers';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_SUPPLIER_',
  }
);

export interface ListSuppliersState {
  data: ListedSupplier[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListSuppliersRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedSupplier[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListSuppliersState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListSuppliersState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListSuppliersState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListSuppliersState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListSuppliersState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listSuppliers = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListSuppliersTypes = Types;
export const ListSuppliersActions = Creators;
